import { reskinStyles } from 'core/components/theme/theme-variant';
const styles = (theme) => ({
  container: {
    position: 'absolute',
    top: 4,
    right: 4
  },
  button: {
    color: theme.colors.action_icon,
    fontSize: 18,
    fontWeight: '600',
    padding: 0,
    ...reskinStyles(theme, { padding: theme.spacing(1), alignSelf: 'center' })
  },
  'icon-small': {
    width: 24,
    height: 24
  },
  'icon-medium': {
    width: 32,
    height: 32
  },
  'icon-big': {
    width: 48,
    height: 48
  },
  'icon-tiny': {
    width: 16,
    height: 16
  }
});

export default styles;
